module.exports = __webpack_public_path__ + "img/bg6.8e6cb7db.jpg";